import React from 'react';

interface InfoIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

export const InfoIcon: React.FC<InfoIconProps> = ({
  size = 16,
  color = '#FFFFFF',
  strokeWidth = 1.06667,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <circle
      cx="8"
      cy="8"
      r="7.46667"
      stroke={color}
      strokeWidth={strokeWidth}
    />
    <text
      x="8"
      y="8"
      textAnchor="middle"
      dominantBaseline="central"
      fontFamily="Rufina, serif"
      fontSize="12.952"
      fontWeight="400"
      fill={color}
    >
      i
    </text>
  </svg>
);

export default InfoIcon;
